<mat-expansion-panel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title><strong>Task info</strong></mat-panel-title>
  </mat-expansion-panel-header>
  <ng-content></ng-content>
</mat-expansion-panel>
